<script>
    // Import the base chart
    import {Bar} from 'vue-chartjs'

    // Extend it
    export default {
        extends: Bar,
        data() {
           return {
               options: {
                   legend: {
                       display: false,
                   },
                   title: {
                       display: false,
                   },
                   axes: {
                       display:false
                   },
                   tooltips: {
                       enabled: true,
                       mode: 'single',
                       callbacks: {
                           label: function(tooltipItems, data) {
                               return tooltipItems.value;
                           }
                       }
                   },
                   scales: {

                       xAxes: [{
                           stacked: true,
                           gridLines: {
                               drawBorder: false,
                               display: false
                           },
                           ticks: {
                               display: false
                           },
                       }],
                       yAxes: [{
                           stacked: true,
                           gridLines: {
                               drawBorder: false,
                               display: false
                           },
                           ticks: {
                               display: false,
                               beginAtZero: true
                           }
                       }]
                   },

                   responsive: true,
                   // aspectRatio:1
                   // maintainAspectRatio: false
               }
           }
        },
        props: ['chartdata'],
        mounted () {
            // Overwriting base render method with actual data and options
            this.renderChart(this.chartdata, this.options)
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Outils/BarChartjsDashboard.vue